import { Helmet } from "react-helmet-async";
import { PageHero } from "@/components/shared/PageHero";
import { CTASection } from "@/components/shared/CTASection";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { serviceAreaCities } from "@/data/serviceAreas";

const ServiceAreas = () => {
  return (
    <>
      <Helmet>
        <title>Service Areas | Riekels Lawn Care & Landscaping - West Twin Cities Metro</title>
        <meta
          name="description"
          content="Riekels Lawn Care & Landscaping serves Maple Grove, Plymouth, Rogers, Medina, Corcoran, and surrounding West Metro Minnesota areas. Call (763) 245-7813."
        />
      </Helmet>
      <main>
        <PageHero
          badge="Service Areas"
          title="Proudly Serving Minnesota"
          subtitle="Quality lawn care, landscaping, and snow removal services throughout the West Twin Cities Metro and surrounding areas."
        />

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
                Our Primary Service Areas
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                We're proud to serve these Minnesota communities with professional lawn care, landscaping, and snow removal services.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {serviceAreaCities.map((area) => (
                <Link 
                  key={area.slug} 
                  to={`/service-areas/${area.slug}`}
                  className="feature-card text-center group hover:border-secondary transition-colors cursor-pointer"
                >
                  <div className="icon-circle mx-auto mb-4 group-hover:bg-secondary group-hover:text-white transition-colors">
                    <MapPin className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-heading font-bold text-foreground mb-2 group-hover:text-secondary transition-colors">
                    {area.name}, MN
                  </h3>
                  <p className="text-muted-foreground text-sm mb-4">
                    {area.description}
                  </p>
                  <span className="text-secondary font-semibold text-sm flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    Learn More <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              ))}
            </div>

            <div className="bg-section-alt rounded-2xl p-8 text-center">
              <h3 className="text-2xl font-heading font-bold text-foreground mb-4">
                And Surrounding Areas
              </h3>
              <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
                Don't see your city listed? We serve many additional communities throughout the West Twin Cities Metro area. Give us a call to confirm we service your area!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/contact">
                  <Button size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold">
                    Get a Free Quote <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
                <a href="tel:+17632457813">
                  <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold">
                    Call (763) 245-7813
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
    </>
  );
};

export default ServiceAreas;
